/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BOOLEAN_STATUS, ENTITYNAME, LOGEVENT, MODULE, OFFER_TYPE, SUBTITLING_CODE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import { Description } from "@mui/icons-material";

export const IngestPrototypeEditForm = (props) => {
  const lang = useTranslation();
  const blankDataItem = {
    ...props.item,
    SID: props.item.SID ?? 0,
    Description: props?.item?.copy ? "Copy of " + props?.item?.Description : props?.item?.Description ?? "",
    DirectIngest: { _id: props.item.DirectIngest, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.DirectIngest) },
    CensorshipFlag:{ _id: props.item.CensorshipFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.CensorshipFlag) },
    AssetGroup: props.item.AssetGroup ?? "",
    DualSound: { _id: props.item.DualSound, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.DualSound) },
    SubtitlesFlag: { _id: props.item.SubtitlesFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.SubtitlesFlag) },
    SubtitlingCode: { _id: props.item.SubtitlingCode, Description: utility.getKeyByValue(SUBTITLING_CODE, props.item.SubtitlingCode) },
    SubtitlingLang: props.item.SubtitlingLang ?? "",
    SubtitlingMode: props.item.SubtitlingMode ?? "",
    Thumbnail: { _id: props.item.Thumbnail, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.Thumbnail) },
    Language1: props?.item?.Language1 ?? "",
    HD: { _id: props.item.HD, Description: utility.getKeyByValue(BOOLEAN_STATUS, props.item.HD) },
    Archive: props.item.Archive ?? false,
  }

  const [dataItem, setDataItem] = useState(blankDataItem); 

  useEffect(() => {
  }, [])

  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
      toast.error(`${lang.please_enter_description_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    };
    if (dataItem.AssetGroup == undefined || dataItem.AssetGroup.trim().length == 0 || dataItem.AssetGroup == "") {
      toast.error(`${lang.please_enter_asset_group_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (!dataItem.DirectIngest || Object.keys(dataItem.DirectIngest).length == 0) {
      toast.error(lang.please_select_direct_ingest_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false
    }
    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {

      const saveData = {
        _id: dataItem._id,
        SID: dataItem.SID ?? 0,
        Description:dataItem.Description ?? "",
        DirectIngest: dataItem.DirectIngest._id,
        CensorshipFlag:dataItem.CensorshipFlag._id,
        AssetGroup: dataItem.AssetGroup ?? "",
        DualSound: dataItem.DualSound._id,
        SubtitlesFlag: dataItem.SubtitlesFlag._id,
        SubtitlingCode: dataItem.SubtitlingCode._id,
        SubtitlingLang: dataItem.SubtitlingLang ?? "",
        SubtitlingMode: dataItem.SubtitlingMode ?? "",
        Thumbnail: dataItem.Thumbnail._id,
        Language1: dataItem.Language1 ?? "",
        HD: dataItem.HD._id,
        Archive: dataItem.Archive ?? false,
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.INGEST_PROTOTYPE, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.INGEST_PROTOTYPE, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.INGEST_PROTOTYPE);
        props.cancelEdit();
        props.refresh();
      }
      else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }

  const onChangeForm = (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Description : "Create Ingest Prototype"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input
                      name={"Description"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Description}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.asset_group_label} *</label>
                    <input
                      name={"AssetGroup"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.AssetGroup}
                    />
                  </div>

                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.direct_ingest_label} *</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(BOOLEAN_STATUS).map((obj) => {
                          return {
                            _id: BOOLEAN_STATUS[obj],
                            Description: obj
                          }
                        })
                      }
                      name="DirectIngest"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.DirectIngest}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.censorship_flag_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(BOOLEAN_STATUS).map((obj) => {
                          return {
                            _id: BOOLEAN_STATUS[obj],
                            Description: obj
                          }
                        })
                      }
                      name="CensorshipFlag"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.CensorshipFlag}
                      onChange={onChangeForm}
                    />
                  </div>

                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.dual_sound_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(BOOLEAN_STATUS).map((obj) => {
                          return {
                            _id: BOOLEAN_STATUS[obj],
                            Description: obj
                          }
                        })
                      }
                      name="DualSound"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.DualSound}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.subtitles_flag_label} </label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(BOOLEAN_STATUS).map((obj) => {
                          return {
                            _id: BOOLEAN_STATUS[obj],
                            Description: obj
                          }
                        })
                      }
                      name="SubtitlesFlag"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.SubtitlesFlag}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row form-group">                  
                  <div className="col-6">
                    <label>{lang.subtitling_code_label} </label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(SUBTITLING_CODE).map((obj) => {
                          return {
                            _id: SUBTITLING_CODE[obj],
                            Description: obj
                          }
                        })
                      }
                      name="SubtitlingCode"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.SubtitlingCode}
                      onChange={onChangeForm}
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="">{lang.thumbnail_label} </label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(BOOLEAN_STATUS).map((obj) => {
                          return {
                            _id: BOOLEAN_STATUS[obj],
                            Description: obj
                          }
                        })
                      }
                      name="Thumbnail"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.Thumbnail}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-6">
                    <label>{lang.subtitling_lang_label} </label>
                    <input
                      name={"SubtitlingLang"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.SubtitlingLang}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.subtitling_mode_label} </label>
                    <input
                      name={"SubtitlingMode"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.SubtitlingMode}
                    />
                  </div>
                </div>
                <div className="row form-group">                  
                  <div className="col-6">
                    <label htmlFor="">{lang.language1_label}</label>
                    <input
                      name={"Language1"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Language1}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.hd_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={
                        Object.keys(BOOLEAN_STATUS).map((obj) => {
                          return {
                            _id: BOOLEAN_STATUS[obj],
                            Description: obj
                          }
                        })
                      }
                      name="HD"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.HD}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row form-group">                  
                  <div className="col-3" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>
                </div>
              </div>
            </div>
          </FormElement>
        )}
      />

    </BossDialog>)
};